import { SUPPORT_STAFF_LIST, SUPPORT_STAFF_DETAIL } from "./actions";

const initialState = {
  supportStaff: {
    docs: [],
    totalDocs: 0,
    limit: 0,
    page: 0,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  supportStaffLoading: true,
  supportStaffData: {},
};

const supportStaffReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUPPORT_STAFF_LIST:
      return {
        ...state,
        supportStaff: payload,
        supportStaffLoading: false,
      };
    case SUPPORT_STAFF_DETAIL:
      return {
        ...state,
        supportStaffData: payload,
        supportStaffLoading: false,
      };
    default:
      return state;
  }
};

export default supportStaffReducer;
